export default __webpack_public_path__ + "static/media/alarm.b0eff7ad.ogg";